module.exports = __webpack_public_path__ + "static/media/cercuri.8d581ffb.png";